import { useEffect, useState, type ReactNode } from 'react';
import { LoaderIcon } from '@mentimeter/ragnar-visuals';
import { Link } from '@mentimeter/ragnar-ui/link';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';

export const MailToLink = (chunks: ReactNode) => (
  <Link color="secondary" href="mailto:hello@mentimeter.com">
    {chunks}
  </Link>
);

export const Loading = ({ onReload }: { onReload?: () => void }) => {
  const t = useTranslations('presenting.quiz');

  const [longWait, setLongWait] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLongWait(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <LoaderIcon />
      {longWait && (
        <>
          <Text mt={3} textAlign="center" fontSize="125">
            {t.rich('loading.connection_issues_message', {
              link: MailToLink,
            })}
          </Text>
          {onReload && (
            <Link fontSize={2} mt={2} onClick={onReload}>
              {t('loading.reload_button')}
            </Link>
          )}
        </>
      )}
    </>
  );
};
